import { faBuilding, faCartShopping, faFileInvoiceDollar, faFilePdf, faMoneyBillTrendUp } from "@fortawesome/free-solid-svg-icons"
import MenuItem from "../../../types/menu/MenuItem"

const CIXNavListInternal: MenuItem[] = [
    {
        id: 1,
        name: 'summaryReview',
        complete: false,
        componentName: 'Summary',
        icon: faFilePdf
    },
    {
        id: 2,
        name: 'contactInfo',
        componentName: 'ContactInfo',
        complete: false,
        icon: faFilePdf
    },
    {
        id: 3,
        name: 'incomeExpense',
        componentName: 'IncomeExpense',
        complete: false,
        icon: faMoneyBillTrendUp,
        subItems: [
            {
                id: 31,
                name: 'revenue',
                complete: false,
                hasTabs: true,
                componentName: 'RevenueContainer',
                subItems: [
                    {
                        id: 311,
                        name: 'rents',
                        complete: false,
                        accordionHeader: 'Rents'
                    },
                    {
                        id: 312,
                        name: 'recoveries',
                        complete: false,
                        accordionHeader: 'Recoveries'
                    },
                    {
                        id: 313,
                        name: 'otherRevenue',
                        complete: false,
                        accordionHeader: 'Other Revenue'
                    },
                    {
                        id: 314,
                        name: 'rentalLoss',
                        complete: false,
                        accordionHeader: 'Rental Loss'
                    },
                ]
            },
            {
                id: 32,
                name: 'expenses',
                complete: false,
                hasTabs: true,
                componentName: 'ExpenseContainer',
                subItems: [
                    {
                        id: 321,
                        name: 'general',
                        complete: false,
                    },
                    {
                        id: 322,
                        name: 'admin',
                        complete: false,
                    },
                    {
                        id: 323,
                        name: 'utilities',
                        complete: false,
                    },
                    {
                        id: 324,
                        name: 'propMaintenance',
                        complete: false,
                    },
                    {
                        id: 325,
                        name: 'other',
                        complete: false,
                    },
                    {
                        id: 326,
                        name: 'nonOperatingIncomeExpenses',
                        complete: false,
                        accordionHeader: 'Non-Operating Expenses'
                    }
                ],
            },
            {
                id: 33,
                name: 'capitalExpSummary',
                complete: false,
                componentName: 'CapitalCostsSummary',
            },
            {
                id: 34,
                name: 'analysis',
                componentName: 'Analysis',
                complete: false
            }
        ],
    },
    {
        id: 4,
        name: 'commercial',
        complete: false,
        icon: faCartShopping,
        subItems: [
            {
                id: 41,
                name: 'leaseInformationTable',
                complete: false,
                componentName: 'LeaseInfo',
            },
            {
                id: 42,
                name: 'vacantAskingRate',
                complete: false,
                componentName: 'VacantAskingRate',
            },
            {
                id: 43,
                name: 'parkingSummary',
                complete: false,
                componentName: 'ParkingPropertySummary',
            }
        ]
    },
    {
        id: 5,
        name: 'apartment',
        complete: false,
        icon: faBuilding,
        subItems: [
            {
                id: 51,
                name: 'suiteBreakdownTable',
                complete: false,
                componentName: 'SuiteBreakdown'
            }
        ]
    },
    {
        id: 6,
        name: 'comments',
        componentName: 'Comment',
        complete: false
    },
    {
        id: 7,
        name: 'submit',
        complete: false,
        componentName: 'Submit',
        icon: faFileInvoiceDollar
    }
]

export default CIXNavListInternal